import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttemptsSection } from '../components/FailedAttemptsSection';
import { RMASystemSection } from '../components/RMASystemSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-primary text-text-primary font-body overflow-x-hidden" data-id="element-394">
      <HeroSection data-id="element-395" />
      <OpeningHook data-id="element-396" />
      <ProblemSection data-id="element-397" />
      <FailedAttemptsSection data-id="element-398" />
      <RMASystemSection data-id="element-399" />
      <WhatYouGetSection data-id="element-400" />
      <WhoIsForSection data-id="element-401" />
      <HowItWorksSection data-id="element-402" />
      <ProofSection data-id="element-403" />
      <TestimonialsSection data-id="element-404" />
      <FAQSection data-id="element-405" />
      <OfferSection data-id="element-406" />
      <ClosingCTA data-id="element-407" />
    </main>;
}